<script>
  import Center from './center.svelte';
</script>

<div>
  <Center>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      ><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line
        x1="12"
        y1="16"
        x2="12.01"
        y2="16"
      /></svg
    >
  </Center>
</div>

<style>
  div {
    margin: 0px auto;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #eb3b5a;
    color: white;
  }

  svg {
    height: 22px;
    width: 22px;
  }
</style>
